module.exports = __webpack_public_path__ + "static/media/szekesfehervar-biztber-kialakitas-resz-projektmendzsment.c83ab20d.jpg";